<template>
    <apexchart  height="320"  type="area" :options="options" :series="series"></apexchart>

</template>

<script>
    import ApexCharts from 'apexcharts'
    var ru = require("apexcharts/dist/locales/ru.json")
    export default {
        name: "ActivationsChart",
        props:{
            lastDays:{
                type:Number,
                default:0
            }
        },
        data(){
            return {
                series: [{
                    name: 'Активации',
                    data:[]
                }],
                options: {
                    chart: {
                        height:"100%",
                        width:'100%',
                        type: 'area',
                        locales:[ru],
                        defaultLocale: 'ru'
                    },
                    tooltip:{
                        enabled:true,
                        enabledOnSeries: false,
                        custom: function({series, seriesIndex, dataPointIndex, w}) {
                            return '<div class="arrow_box tooltip_box">' +
                                '<span class="tooltip_count">' + series[seriesIndex][dataPointIndex] + '</span>' +
                                    '<div class="tooltip_date">'+new Date(w.config.series[seriesIndex].data[dataPointIndex].x).toLocaleDateString()+'</div>'
                                '</div>'
                        }
                    },
                    yaxis: {
                     min:0,
                    },
                    xaxis: {
                        type: "datetime",
                        labels:{
                            datetimeUTC: false
                        }
                    }
                }
            }
        },
        mounted(){
            this.getDataChart()
        },

        methods:{
            getDataChart(){
                this.$store.dispatch("Statistic/loadChartData", this.lastDays).then((dataChart)=>{
                    this.series=[{
                        data:dataChart
                    }]
                })
            }
        },
        watch:{
            lastDays(value){
                this.getDataChart()
            }
        }


    }
</script>

<style>
    .tooltip_box{
        background: #FFFFFF;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        padding:10px 20px;
        text-align: center;

    }
    .tooltip_count{
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        align-items: center;
        text-align: center;
        color:black;
    }
.tooltip_date{
    font-size: 13px;
    line-height: 16px;
    align-items: center;
    color: #6E7C8D;
}

</style>